import ServiceContentModel from './ServiceContent.model';

export default class ServicesContent {
  constructor({
    elements: data, scenario, label, phones,
  }) {
    this.data = data;
    this.scenario = scenario;
    this.label = label;
    this.phones = phones;
  }

  getLabel() {
    return this.label || '';
  }

  getServicesNames() {
    return Object.keys(this.data || {});
  }

  getServiceContentByName(name) {
    const flattedServices = Object.values(this.data[name] || {}).map((group) => Object.values(group)).flat();
    return ((name && flattedServices) || []).map((val) => new ServiceContentModel(val));
  }

  serviceContentByNameContains(name, what) {
    return ((name && this.getServiceContentByName(name)) || []).filter((el) => el.getName().toLowerCase().includes(what)).length > 0;
  }

  getServiceContentModeListByName(name) {
    return new Set(this.getServiceContentByName(name).map((val) => val.getMmpec()).sort());
  }

  getServiceContentByNameAndMode(name, mode) {
    return ((name && this.getServiceContentByName(name)) || []).reduce((acc, val) => (
      val.getMmpec() === mode ? [...acc, val] : acc),
    []);
  }

  getServicesCase3() {
    if (this.scenario === '3') {
      return Object.values(this.data).map((service) => new ServiceContentModel(service));
    }
    return [];
  }

  getServiceNumberByName(name) {
    return this.data[name].nbCards;
  }

  getServiceCount() {
    return Object.values(this.data)
      .reduce((acc, current) => acc + current.nbCards, 0);
  }

  getScenario() {
    return this.scenario;
  }

  getPhones() {
    return this.phones || [];
  }
}
